export default "__VITE_ASSET__d9e860ac__"